import axios from 'axios'

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://app.mobilassistance.com'

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

const API_ENDPOINTS = {
  CCN_SET_PAYMENT: '/yolyardim-service/api/Price/set-payment',
  CCN_VERIFY_3D: '/yolyardim-service/api/Price/verify-3d-payment',
}

function unwrapData(payload) {
  if (!payload) return null
  return payload.data ?? payload.Data ?? null
}

function getStatusCode(payload, httpStatus) {
  const status = payload?.statu ?? payload?.Statu
  if (typeof status === 'number') return status
  if (status && typeof status === 'object') {
    const code = status.statusCode ?? status.StatusCode
    if (code != null) return Number(code)
  }
  return httpStatus != null ? Number(httpStatus) : null
}

function readStatusMessage(payload, fallback) {
  const status = payload?.statu ?? payload?.Statu
  const exceptions = payload?.exceptions || payload?.Exceptions
  if (status && typeof status === 'object') {
    if (status.description) return status.description
    if (status.message) return status.message
  }
  if (Array.isArray(exceptions) && exceptions.length > 0) {
    const first = exceptions[0]
    if (typeof first === 'string') return first
    if (first?.message) return first.message
    if (first?.Message) return first.Message
  }
  return fallback
}

export const cekiciAPI = {
  setPayment: (payload) =>
    api.post(API_ENDPOINTS.CCN_SET_PAYMENT, payload, { timeout: 60000 }),
  verify3dPayment: (payload) =>
    api.post(API_ENDPOINTS.CCN_VERIFY_3D, payload, { timeout: 30000 }),
  unwrapData,
  getStatusCode,
  readStatusMessage,
}

export default api
